export const mockData = {
  company: {
    name: "TruBridge Health",
    tagline: "Your Trusted Partner in Medicare & Health",
    phone: "(914) 266-0223",
    phoneTel: "+19142660223",
    email: "info@trubridgehealth.com",
    address: "Serving Westchester County and the New York tri-state area",
    city: "",
    state: "",
    zip: "",
    npn: "21606228",
    mission: "Our mission is to provide personalized health insurance solutions to residents of Westchester County and the New York Tri-State area that protect what matters most - your health and financial wellbeing. We specialize in Medicare plans and are committed to helping local seniors navigate their healthcare options with clarity and confidence.",
    socialMedia: {
      facebook: "https://facebook.com/trubridge",
      instagram: "https://instagram.com/trubridge"
    }
  },
  services: [
    {
      id: 1,
      title: "Medicare Advantage Plans",
      description: "Comprehensive Medicare Advantage plans that combine Parts A, B, and often Part D with additional benefits like dental and vision coverage.",
      icon: "shield-check"
    },
    {
      id: 2,
      title: "Medicare Supplement Insurance",
      description: "Medigap policies that help cover costs not paid by Original Medicare, giving you peace of mind and financial protection.",
      icon: "heart-pulse"
    },
    {
      id: 3,
      title: "Dental and Vision Plans",
      description: "Maintain your oral and eye health with affordable dental and vision coverage. From routine checkups and cleanings to eyeglasses and contact lenses, we help you find plans that keep you healthy and your costs manageable.",
      icon: "pill"
    },
    {
      id: 4,
      title: "Long-Term Care Insurance",
      description: "Protect your future with long-term care coverage that helps pay for services like nursing home care, assisted living, and in-home care. We help you plan ahead to preserve your assets and maintain independence as you age.",
      icon: "users"
    },
    {
      id: 5,
      title: "Life Insurance",
      description: "Protect your loved ones with comprehensive life insurance coverage that provides financial security. We also offer annuities to help you create guaranteed income streams for retirement, ensuring peace of mind for you and your family.",
      icon: "shield"
    },
    {
      id: 6,
      title: "Retirement Planning",
      description: "Free personalized consultations to help you prepare financially for retirement. We work with you to ensure you can maintain your lifestyle, cover healthcare costs, and feel secure throughout your retirement years.",
      icon: "clipboard-list"
    }
  ],
  agents: [
    {
      id: 1,
      name: "Adeen Schwartz",
      title: "Founder & Senior Insurance Advisor",
      experience: "15+ years",
      specialties: ["Medicare Advantage", "Medicare Supplement", "Part D", "Health Insurance"],
      bio: "Adeen founded TruBridge Health Solutions with a mission to provide personalized, trustworthy insurance guidance to individuals and families throughout Westchester County and the New York Tri-State area. With over 15 years of experience serving local communities, Adeen specializes in helping clients navigate Medicare options and find the right coverage for their unique needs.",
      certifications: ["Licensed Insurance Agent", "AHIP Certified", "Medicare Specialist"],
      photo: "placeholder" // Will be updated with actual photo
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Domenick",
      text: "My wife and I were looking to make a change from Medicare to Medicare Advantage to save money. Adeen worked with us until he found the right plan for us which is working great. We have already recommended him to family and friends and he is always available to answer any questions. If I could give him 10 Stars I would!",
      rating: 5,
      location: "NY Tri-State Area"
    },
    {
      id: 2,
      name: "Steven",
      text: "Adeen was the best agent I ever had. My wife has end stage renal disease which requires dialysis treatment. Adeen was very helpful and helped us find the right plan. He went to the extent to check all the doctors and I feel he went well above and beyond his duty. I would highly recommend Adeen for your Medicare and other insurance needs. He's very knowledgeable, helpful and friendly.",
      rating: 5,
      location: "NY Tri-State Area"
    },
    {
      id: 3,
      name: "Sally",
      text: "Adeen was very helpful in assisting me with decisions regarding my advantage plan. He listened to my concerns and took the time to research what would work best for me. I appreciated so much having his expertise in helping me to make these decisions.",
      rating: 5,
      location: "Westchester County, NY"
    },
    {
      id: 4,
      name: "Leanne",
      text: "Adeen was very helpful with my changing from NY State Health to Medicare Advantage. He took the time to research what companies covered all of my doctors.",
      rating: 5,
      location: "New York"
    },
    {
      id: 5,
      name: "Brandon",
      text: "Adeen was very knowledgeable about the different plans available and helped me pick a plan that met my needs. He walked me through the whole process and made sure my enrollment went through without a hitch.",
      rating: 5,
      location: "Westchester County, NY"
    },
    {
      id: 6,
      name: "Shana",
      text: "Adeen was professional, thorough, and extremely helpful in helping choose the right healthcare providers for my mother. He made it easy and was a pleasure to work with!",
      rating: 5,
      location: "NY Tri-State Area"
    }
  ],
  faqs: [
    {
      id: 1,
      question: "When can I enroll in Medicare?",
      answer: "You can first enroll in Medicare during your Initial Enrollment Period, which begins 3 months before you turn 65 and ends 3 months after. There's also an Annual Enrollment Period (October 15 - December 7) when you can make changes to your coverage."
    },
    {
      id: 2,
      question: "What's the difference between Medicare Advantage and Medicare Supplement?",
      answer: "Medicare Advantage (Part C) is an alternative to Original Medicare offered by private insurers, often including extra benefits. Medicare Supplement (Medigap) works alongside Original Medicare to help cover out-of-pocket costs like copays and deductibles."
    },
    {
      id: 3,
      question: "Do I need Medicare Part D if I don't take many medications?",
      answer: "Even if you don't currently take medications, enrolling in Part D when you're first eligible helps you avoid late enrollment penalties. Your prescription needs may change, and having coverage ensures you're protected."
    },
    {
      id: 4,
      question: "How much does Medicare cost?",
      answer: "Medicare costs vary based on the parts you enroll in and your income. Most people don't pay a premium for Part A. Part B has a standard monthly premium (around $174.70 in 2024). Additional costs depend on whether you choose Medicare Advantage, Medigap, or Part D plans."
    },
    {
      id: 5,
      question: "Can I change my Medicare plan?",
      answer: "Yes! You can change your Medicare Advantage or Part D plan during the Annual Enrollment Period (October 15 - December 7) each year. For Medigap plans, you have guaranteed issue rights during certain circumstances."
    },
    {
      id: 6,
      question: "Do you charge for consultations?",
      answer: "No, our consultations are completely free. We're compensated by insurance carriers, so there's no cost to you for our services. We're here to help you find the best coverage for your needs."
    },
    {
      id: 7,
      question: "What areas of Westchester County and the Tri-State area do you serve?",
      answer: "We proudly serve all of Westchester County including White Plains, Yonkers, New Rochelle, Mount Vernon, and surrounding communities. We also extend our services throughout the greater New York Tri-State area including parts of Connecticut and New Jersey. Whether you prefer in-person meetings or virtual consultations, we're here to help you navigate your Medicare options."
    }
  ]
};
